import {Component, input, output, OutputEmitterRef} from '@angular/core';
import {CovIconComponent, IconName} from '@cov/ui-angular';
import {TranslocoPipe} from '@jsverse/transloco';
import {DividerComponent} from '../../../../shared/ui/divider/divider.component';
import {formatFileSize} from '../../../../shared/utils/file.utils';

@Component({
  selector: 'cov-inquiry-attached-files',
  imports: [CovIconComponent, TranslocoPipe, DividerComponent],
  templateUrl: './inquiry-attached-files.component.html',
  styleUrl: './inquiry-attached-files.component.scss',
})
export class InquiryAttachedFilesComponent {
  public files = input<File[]>([]);

  public fileDeleted: OutputEmitterRef<File> = output();

  protected readonly IconName = IconName;
  protected readonly formatFileSize = formatFileSize;
}
